import $ from "jquery";





const onAccordionHeadingClick = function(e) {

  console.log('onAccordionHeadingClick');

  if ($(this).parent().hasClass("accordion--open")) {
    $(this).parent().removeClass("accordion--open")
  } else {
    $(this).parent().addClass("accordion--open")
  }

}




export const initAccordions= function() {

  $('.accordion').on('click',onAccordionHeadingClick);
  
};